import { tierFor } from "@/lib/tiers";

/**
 * Tiny colored "portal" dot standing in for the tier ring where there is no avatar
 * (e.g. dense message-board rows). Color reflects the user's thank tier.
 */
export default function TierDot({ count = 0, size = 9, testid = "tier-dot" }) {
    const t = tierFor(count);
    const n = Number(count) || 0;
    return (
        <span
            data-testid={testid}
            title={`${t.name} · ${n.toLocaleString()} thanks`}
            className="inline-block rounded-full shrink-0 align-middle"
            style={{ width: size, height: size, backgroundColor: t.color, boxShadow: `0 0 0 1.5px ${t.color}55` }}
        />
    );
}
